import axios from 'axios'
import router from '@/router'
// import ApiSystem from '@/service/api.service'
import Cookies from 'vue-cookie'

// axios 配置
axios.defaults.baseURL = 'http://user.ihuyi.com/wxeditor/api'
// axios.defaults.baseURL = '/api'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.common['token'] = Cookies.get('token');
// http response 拦截器
/* eslint consistent-return: [0, { "treatUndefinedAsUnspecified": false }] */
axios.interceptors.response.use(response => response, (error) => {
  if (error.response) {
    switch (error.response.status) {
      case 401:
      Cookies.delete('token')
        axios.get('upload.php?act=login').then(({data}) => {
          Cookies.set('token', data.data.token, 1)
        })
        break
      default:
        break
    }
    return Promise.reject(error.response.data)
  }
})

export default axios



// WEBPACK FOOTER //
// ./src/service/http.js